var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#172536"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16471 17.5H8.3327L9.16471 11.6667H6.25269C5.77013 11.6667 5.77845 11.4 5.93653 11.1167C6.09461 10.8333 5.97813 11.05 5.99477 11.0167C7.06806 9.11667 8.68215 6.28333 10.8287 2.5H11.6607L10.8287 8.33333H13.7407C14.1484 8.33333 14.2067 8.60833 14.1318 8.75833L14.0735 8.88333C10.7954 14.625 9.16471 17.5 9.16471 17.5Z",
    fill: "#FDA536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBev);
export default __webpack_public_path__ + "static/media/bev.17a2fa6e899cb00771d227153e9983f8.svg";
export { ForwardRef as ReactComponent };